
export default class Scens {
    constructor(controller) {
        this.controller = controller;
    }

    animation() {

        const animations = document.querySelectorAll("[data-animation='true']");

        if (animations) {

            animations.forEach(e => {

                const item = e.dataset.item;
                let deley = 0;
                //console.log(e);

                if (item == 'header') {
                    //console.log('ds');
                    deley = 4000;
                }

                new ScrollMagic.Scene({
                    triggerElement: e,
                    duration: '100%',
                    offset: -100,
                    reverse: false,
                })
                .on('start', function () {
        
                    setTimeout(() => {
                        e.classList.add("animation-active");
                    },deley);
        
                })
                .addTo(this.controller);
            });

        }
    }

    map(getMapboxLoad) {

        const map_block = document.querySelector("[data-item='map']");

        if (map_block) {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="map"]',
            duration: '100%',
            offset: -500,
            reverse: false
        })
            .on('start', function () {
                const id = map_block.getAttribute("id");
                const address = map_block.dataset.address;
                let lng = parseFloat(map_block.dataset.lng);
                let lat = parseFloat(map_block.dataset.lat);

                getMapboxLoad.then(res => {
                    mapboxgl.accessToken = 'pk.eyJ1IjoicHl6bGFrIiwiYSI6ImNqbHFka285YTJld3czcGttYTBrNmsxbmMifQ.iGqgEnhIVafu65sbjPFwog';
                    lng = lng;
                    lat = lat;
                    
                    var map = new mapboxgl.Map({
                        container: id,
                        center: [lng, lat],
                        zoom: 14,
                        dragPan: window.innerWidth > 992 ? true : false,
                        style: 'mapbox://styles/pyzlak/ckgj9b97h0pwc19m6q1tl1m64'
                    });

                    var geojson = {
                        type: 'FeatureCollection',
                        features: [{
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [lng, lat]
                            }
                        }]
                    };
                    
                    geojson.features.forEach(function(marker) {
                        var el = document.createElement('div');
                        el.className = 'marker';
                    
                        new mapboxgl.Marker(el)
                            .setLngLat(marker.geometry.coordinates)
                            .setPopup(new mapboxgl.Popup({offset: 25})
                            .setHTML(address))
                            .addTo(map);
                    });
                    
                    map.scrollZoom.disable();
                    
                    map.addControl(new mapboxgl.NavigationControl(), 'top-left');
                    }).catch(e => {
                        console.log(e);
                    });

                      
            })
            .addTo(this.controller);
        
        }
    
    }
    
    
}